import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Base configuration shared by S3ReaderConfig and S3WriterConfig.
 * Holds AWS credentials, the target bucket, and an object key filter.
 */
export class S3ConnectorBase extends DestinationTaskConfigBase {
	/** AWS region (e.g. 'eu-west-1'). @default '' */
	awsRegion = '';
	/** AWS access key ID. @default '' */
	awsAccessKeyId = '';
	/** AWS secret access key. @default '' */
	awsSecretAccessKey = '';
	/** S3 bucket name. Supports expression syntax. @default '' */
	awsBucketName = '';
	/** Prefix or glob pattern to filter which objects are read/written. Leave empty for all objects. @default '' */
	objectFilter = '';

	constructor(init?: Partial<S3ConnectorBase>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
